<template>
  <div style="position: relative; min-height: 600px">
    <ul class="headerList fl">
      <div :class="{ leadList: stepList == 1 && !initType }">
        <!-- <li>
          <label class="tit">因子:</label>
          <p>
            <el-select
              v-model="param.factorName"
              placeholder="请选择"
              style="width:180px;"
              size="small"
            >
              <el-option
                v-for="(item,idx) in subjectData.factorInfoTOList"
                :key="idx"
                :label="item.factor_name"
                :value="item.factor_no"
              ></el-option>
            </el-select>
          </p>
        </li> -->
        <li>
          <label class="tit">因子:</label>
          <p>
            <span class="titCen">{{ getKsubject.factor_name }}</span>
            <el-button
            size="small"
              @click="symbolfun('divisor')"
              style="margin-left: 10px"
              >更换因子</el-button>
          </p>
        </li>
        <div
          class="digBox"
          v-if="stepList == 1 && stepType <= newGuideIdx"
          style="right: -106px; top: 27px"
        >
          <img src="../../assets/image/lead1.png" style="margin-left: 23px" />
          <h3 style="margin: -15px 0 0 -4px;">请选择因子</h3>
        </div>
      </div>
      <div :class="{ leadList: stepList == 2 && !initType }">
        <li>
          <label class="tit">投资域:</label>
          <p>
            <el-select
              v-model="param.investmentDomain"  @change="articleChange"
              placeholder="请选择"
              style="width: 180px"
              size="small"
            >
              <el-option
                v-for="(item, idx) in subjectData.codeDataTOList"
                :key="idx"
                :label="item.name"
                :value="item.symbol"
              ></el-option>
            </el-select>
          </p>
          <p class="titList">
            <span>调仓频率：日</span>
            <span>分位组数：5</span>
            <span>因子方向：正向</span>
          </p>
        </li>
        <div
          class="digBox"
          v-if="stepList == 2 && stepType <= newGuideIdx"
          style="right: -106px; top: 27px"
        >
          <img src="../../assets/image/lead1.png" style="margin-left: 23px" />
          <h3 style="margin-left: -22px;">请选择投资域</h3>
        </div>
      </div>
    </ul>
    <div class="fl">
      <div :class="{ leadList: stepList == 3 && stepType <= newGuideIdx }" style="padding: 0;">
        <el-button
          type="primary"
          size="small"
          @click="codeDataChange"
          >运行回测</el-button
        >
        <div
          class="digBox"
          v-if="stepList == 3 && stepType <= newGuideIdx"
          style="right: -106px; top: 27px"
        >
          <img src="../../assets/image/lead1.png" style="margin-left: 140px" />
          <h3 style="margin-left: -157px;">点击运行回测查看因子对应绩效报告</h3>
        </div>
      </div>
    </div>
    <div>
      <ul class="navSvg">
        <li @click="tab(1, 'trajectory')" :class="tabList == 1 ? 'sele' : ''">
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            style="vertical-align: middle; margin-right: 6px"
          >
            <path
              d="M14.72,14.43944 L14.72,2.15608 L11.61144,2.15608 L11.61144,14.43944 L9.23432,14.43944 L9.23432,6.55608 L6.12568,6.55608 L6.12568,14.43944 L3.74856,14.43944 L3.74856,10.40608 L0.64,10.40608 L0.64,14.43944 L2.91322522e-13,14.43944 L2.91322522e-13,15.35608 L15.36,15.35608 L15.36,14.43944 L14.72,14.43944 Z M1.55432,14.43944 L1.55432,11.32272 L2.83432,11.32272 L2.83432,14.43944 L1.55432,14.43944 L1.55432,14.43944 Z M7.04,14.43944 L7.04,7.47272 L8.32,7.47272 L8.32,14.43944 L7.04,14.43944 L7.04,14.43944 Z M12.52568,14.43944 L12.52568,3.07272 L13.80568,3.07272 L13.80568,14.43944 L12.52568,14.43944 Z"
              :class="tabList == 1 ? 'change-sele-color' : 'change-my-color'"
            />
          </svg>
          <!-- <img src="@/assets/image/svg/celue01.svg" class="iconAdd"/> -->
          业绩走势
        </li>
        <li @click="tab(2, 'earnings')" :class="tabList == 2 ? 'sele' : ''">
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            style="vertical-align: middle; margin-right: 6px"
          >
            <path
              :class="tabList == 2 ? 'change-sele-color' : 'change-my-color'"
              d="M10.8671632,3.1476634 C10.9483105,3.24685337 10.9960142,3.38423316 10.9997614,3.52952705 C11.0035086,3.67482093 10.9629917,3.81610368 10.8871398,3.92223943 L8.81468761,6.8258347 C8.73349375,6.94010682 8.61886041,7.00343991 8.49970833,6.99985571 C8.38086605,7.00316834 8.26660016,6.93985149 8.1856582,6.8258347 L6.11274148,3.92223943 C6.01066666,3.779201 5.97460941,3.57570477 6.01815216,3.38840581 C6.0616949,3.20110685 6.17822246,3.05846032 6.32384002,3.0141998 C6.46945758,2.96993927 6.62204237,3.03078897 6.72411718,3.1738274 L8.49970833,5.6624495 L10.2762286,3.1738274 C10.4338997,2.95289253 10.6984602,2.94117895 10.8671632,3.1476634 L10.8671632,3.1476634 Z"
            />
            <path
              :class="tabList == 2 ? 'change-sele-color' : 'change-my-color'"
              d="M14.442953,0 C15.3028863,0 16,0.697113678 16,1.55704698 L16,14.442953 C16,15.3028863 15.3028863,16 14.442953,16 L2.63087248,16 C1.77093918,16 1.0738255,15.3028863 1.0738255,14.442953 L1.07322893,11.435645 L0.483221477,11.4362416 C0.23977077,11.4363762 0.0342361415,11.255383 0.00357941834,11.0138702 L0,10.9530201 C0,10.6861443 0.216345624,10.4697987 0.483221477,10.4697987 L1.07322893,10.4692021 L1.07322893,6.06651752 L0.483221477,6.06711409 C0.23977077,6.0672487 0.0342361415,5.88625552 0.00357941834,5.64474273 L0,5.58389262 C0,5.31701677 0.216345624,5.10067114 0.483221477,5.10067114 L1.07322893,5.10007457 L1.0738255,1.55704698 C1.0738255,0.697113678 1.77093918,0 2.63087248,0 L14.442953,0 Z M14.442953,0.966442953 L2.63087248,0.966442953 C2.30469089,0.966442953 2.04026846,1.23086538 2.04026846,1.55704698 L2.03967189,5.57494407 L2.04026846,5.58389262 L2.04026846,5.59284116 L2.03967189,10.9440716 L2.04026846,10.9530201 L2.04026846,14.442953 C2.04026846,14.7692767 2.30454884,15.033557 2.63087248,15.033557 L14.442953,15.033557 C14.7691346,15.033557 15.033557,14.7691346 15.033557,14.442953 L15.033557,1.55704698 C15.033557,1.23086538 14.7691346,0.966442953 14.442953,0.966442953 Z M5.85234899,8 C5.55582027,8 5.31543624,7.75961597 5.31543624,7.46308725 C5.31543624,7.16655852 5.55582027,6.9261745 5.85234899,6.9261745 L11.2214765,6.9261745 C11.5180052,6.9261745 11.7583893,7.16655852 11.7583893,7.46308725 C11.7583893,7.75961597 11.5180052,8 11.2214765,8 L9.0738255,8 L9.07322893,9.0738255 L11.2214765,9.0738255 C11.4919683,9.07378882 11.7202515,9.27497458 11.7542133,9.54332588 L11.7583893,9.61073826 C11.7583893,9.90726698 11.5180052,10.147651 11.2214765,10.147651 L9.07322893,10.147651 L9.0738255,12.235645 C9.07386219,12.5061368 8.87267642,12.7344201 8.60432513,12.7683818 L8.53691275,12.7725578 C8.24038403,12.7725578 8,12.5321738 8,12.235645 L7.99940343,10.147651 L5.85234899,10.147651 C5.58185719,10.1476877 5.35357398,9.94650193 5.31961223,9.67815063 L5.31543624,9.61073826 C5.31543624,9.31420953 5.55582027,9.0738255 5.85234899,9.0738255 L7.99940343,9.0738255 L8,8 L5.85234899,8 Z"
            />
          </svg>
          <!-- <img src="@/assets/image/svg/celue2.svg" class="iconAdd" /> -->
          收益详情
        </li>
        <li @click="tab(3, 'distribution')" :class="tabList == 3 ? 'sele' : ''">
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            style="vertical-align: middle; margin-right: 6px"
          >
            <path
              :class="tabList == 3 ? 'change-sele-color' : 'change-my-color'"
              d="M11.8780092,12.0253931 C11.9108181,12.0441931 11.9440516,12.0543931 11.9776926,12.0543931 C12.0113507,12.0543931 12.0445841,12.0253931 12.0773931,12.0253931 L11.8780092,12.0253931 Z M13.051995,11.0598264 C13.051995,11.0397067 13.0374314,11.0198063 13.0374314,11 L13.0374314,11.1196528 C13.0374314,11.0998464 13.051995,11.0799304 13.051995,11.0598264 Z M3.09968346,12.0543931 C3.1333245,12.0543931 3.16655798,12.0441931 3.19936692,12.0253931 L3,12.0253931 C3.03280893,12.0441931 3.06604241,12.0543931 3.09968346,12.0543931 Z"
            />
            <path
              :class="tabList == 3 ? 'change-sele-color' : 'change-my-color'"
              d="M14.4977679,13.9955357 L1.00446429,13.9955357 L1.00446429,0.502232143 C1.00446429,0.224866071 0.779598214,0 0.502232143,0 C0.224866071,0 0,0.224866071 0,0.502232143 L0,13.9955357 C0,14.5502846 0.449715402,15 1.00446429,15 L14.4977679,15 C14.7751339,15 15,14.7751339 15,14.4977679 C15,14.2204018 14.7751339,13.9955357 14.4977679,13.9955357 Z"
            />
            <path
              :class="tabList == 3 ? 'change-sele-color' : 'change-my-color'"
              d="M2.16640692,11.8772824 C2.25634765,11.9564676 2.37242635,12.0001331 2.49263431,12 C2.62894706,12 2.76465201,11.9441538 2.86203234,11.8347782 L6.45799162,7.79632716 L8.90317756,10.3488284 L13.9003097,3.78436377 C14.0644172,3.5687766 14.0214437,3.261918 13.8043093,3.09897989 C13.5871748,2.93604179 13.2780974,2.97870907 13.1140227,3.19429624 L8.81706628,8.83898421 L6.43146172,6.3486735 L2.12361411,11.186614 C1.94332579,11.3890715 1.96249631,11.6982951 2.16640692,11.8772824 Z"
            />
          </svg>
          <!-- <img src="@/assets/image/svg/celue02.svg" class="iconAdd" /> -->
          因子分布情况
        </li>
        <li @click="tab(4, 'pertinence')" :class="tabList == 4 ? 'sele' : ''">
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            style="vertical-align: middle; margin-right: 6px"
          >
            <path
              :class="tabList == 4 ? 'change-sele-color' : 'change-my-color'"
              d="M8.03341067,1.10273973 L6.91058362,1.13127854 C3.05322149,1.41381279 0,4.62442922 0,8.55194064 C0,12.6655251 3.3313582,16 7.44800999,16 C11.3784758,16 14.5870427,12.9417808 14.8714617,9.08675799 L14.89602,7.96689498 L8.03341067,7.96689498 L8.03341067,1.10273973 Z M13.7629127,9.10844749 C13.4836338,12.533105 10.7628056,14.8995434 7.44286989,14.8995434 C3.93674817,14.8995434 1.0936998,12.0570776 1.0936998,8.55308219 C1.0936998,5.23515982 3.46442977,2.51426941 6.89116545,2.23458904 L6.89116545,9.10844749 L13.7629127,9.10844749 Z M8.60453329,0 L8.60453329,7.39611872 L16,7.39611872 C16,3.40068493 12.6023916,0 8.60453329,0 Z M9.74677851,1.18664384 C10.3179011,1.26826484 10.6291629,1.40410959 11.0746386,1.59246575 C11.8319472,1.91210046 12.4853114,2.37043379 13.0695699,2.9543379 C13.6538283,3.53824201 14.0993039,4.16780822 14.4197037,4.92465753 C14.6081742,5.36986301 14.7303944,5.68378995 14.8126361,6.25456621 L9.74677851,6.25456621 L9.74677851,1.18664384 Z"
            />
          </svg>
          <!-- <img src="@/assets/image/svg/celue03.svg" class="iconAdd" /> -->
          相关性分析
        </li>
        <li @click="tab(5, 'forecast')" :class="tabList == 5 ? 'sele' : ''">
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            style="vertical-align: middle; margin-right: 6px"
          >
            <path
              :class="tabList == 5 ? 'change-sele-color' : 'change-my-color'"
              d="M8.4690346,14.5758684 L1.67213114,14.5758684 C1.36247723,14.5758684 1.11475408,14.3272395 1.11475408,14.0164534 L1.11475408,1.67824498 C1.11475408,1.36745888 1.36247723,1.11882999 1.67213114,1.11882999 L13.9653916,1.11882999 C14.2750455,1.11882999 14.5227687,1.36745888 14.5227687,1.67824498 L14.5227687,8.43784278 L15.6375228,8.43784278 L15.6375228,1.67824498 C15.6375228,0.74588666 14.8943534,0 13.9653916,0 L1.67213114,0 C0.743169382,0 0,0.74588666 0,1.67824498 L0,14.0164534 C0,14.9488117 0.743169405,15.6946983 1.67213114,15.6946983 L8.4690346,15.6946983 L8.4690346,14.5758684 Z M3.88615664,6.55758683 L6.11566483,8.81078611 C6.30145718,8.99725778 6.61111109,9.02833638 6.82786885,8.87294334 L11.6739526,5.50091409 C11.9216758,5.32998173 11.9990892,4.97257773 11.8132969,4.72394881 C11.6429872,4.47531991 11.2868853,4.39762341 11.0391621,4.58409507 L6.58014571,7.67641682 L4.67577412,5.76508227 C4.45901638,5.547532 4.10291437,5.547532 3.88615664,5.76508227 C3.6693989,5.98263253 3.6693989,6.34003656 3.88615664,6.55758683 Z M11.9526412,10.2714808 L12.1074681,10.8308958 C12.8351548,10.8308958 13.4080146,11.4213894 13.4080146,12.1361974 C13.4080146,12.8665448 12.8196721,13.4414991 12.1074681,13.4414991 C11.3952641,13.4414991 10.8069217,12.8510055 10.8069217,12.1361974 C10.8069217,11.4058501 11.3952641,10.8308958 12.1074681,10.8308958 L12.2622951,10.2714808 L12.1074681,9.71206581 C10.7759563,9.71206581 9.69216758,10.7998172 9.69216758,12.1361974 C9.69216758,13.4725777 10.7759563,14.5603291 12.1074681,14.5603291 C13.43898,14.5603291 14.5227687,13.4725777 14.5227687,12.1361974 C14.5227687,10.7998172 13.43898,9.71206581 12.1074681,9.71206581 L12.1074681,10.2714808 L11.9526412,10.2714808 Z M13.5473588,14.0164534 L16.1484517,17 L17,16.2696526 L14.2285974,13.1151737"
            />
          </svg>
          <!-- <img src="@/assets/image/svg/celue04.svg" class="iconAdd" /> -->
          预测能力分析
        </li>
        <li @click="tab(6, 'modem')" :class="tabList == 6 ? 'sele' : ''">
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            style="vertical-align: middle; margin-right: 6px"
          >
            <path
              :class="tabList == 6 ? 'change-sele-color' : 'change-my-color'"
              d="M14.6538905,9.57142 C14.9034946,9.64061668 15.0511095,9.90376804 14.9836757,10.1593239 C14.0646536,13.6057384 11.007525,15.9973165 7.51760231,16 C4.79874862,16 2.32161248,14.5211293 0.936889606,12.2318528 L0.936889606,15.5204699 C0.936889606,15.7853071 0.727159724,16 0.468444803,16 C0.209729882,16 0,15.7853071 0,15.5204699 L0,10.1228796 C0,9.85804243 0.209729882,9.64334951 0.468444803,9.64334951 C0.489993257,9.64334951 0.508731064,9.65294012 0.528405746,9.6558173 C0.737293511,9.65117058 0.92289795,9.7915 0.979986536,9.99724269 C1.80726008,12.9664928 4.49519638,15.0409399 7.51760231,15.0409399 C10.5812314,15.0409399 13.2794735,12.9310076 14.0795772,9.90900917 C14.1471743,9.65349854 14.4042424,9.50239042 14.6538905,9.57142 L14.6538905,9.57142 Z M0.441275011,6.33363302 C0.322617916,6.29587364 0.223477572,6.21140215 0.165669904,6.09880659 C0.107862236,5.98621103 0.0961240379,5.85471755 0.133038311,5.7332614 C1.13147887,2.41908708 4.12960707,0.163032162 7.51760231,0.176467047 C10.1488201,0.172494894 12.5989917,1.54725623 14.0111843,3.81993645 L14.0111843,0.479530053 C14.0111843,0.214692918 14.2209142,0 14.4796291,0 C14.738344,0 14.9480739,0.214692918 14.9480739,0.479530053 L14.9480739,5.8752023 C14.9480739,6.14086196 14.7391475,6.35473235 14.4796291,6.35473235 C14.4608913,6.35473235 14.4449642,6.34610081 14.4262264,6.3441827 C14.4009303,6.34226459 14.3793819,6.33459209 14.3540859,6.32883773 C14.3297268,6.3221243 14.3053676,6.31828808 14.2828823,6.3077384 C14.1514276,6.25674542 14.0497384,6.14735685 14.0064998,6.01042978 C13.1249744,3.1023898 10.4920263,1.12433952 7.51760231,1.13552718 C4.54029109,1.12338822 1.90539612,3.10573041 1.02776791,6.01810225 C0.990881397,6.13956724 0.908362627,6.24105363 0.798369928,6.30022925 C0.688377229,6.35940487 0.559923467,6.37142084 0.441275011,6.33363302 L0.441275011,6.33363302 Z"
            />
          </svg>
          <!-- <img src="@/assets/image/svg/celue04.svg" class="iconAdd" /> -->
          调仓情况
        </li>
      </ul>
      <div class="boxDetails" v-loading="loading" v-if="getData.sParam">
        <!-- 业绩走势 -->
        <trajectory
          v-if="tabList == 1"
          ref="trajectory"
          :getData="getData"
        ></trajectory>
        <!-- 收益详情 -->
        <earnings
          v-if="tabList == 2"
          ref="earnings"
          :getData="getData"
        ></earnings>
        <!-- 因子分布情况 -->
        <distribution
          v-if="tabList == 3"
          ref="distribution"
          :getData="getData"
        ></distribution>
        <!-- 相关性分析 -->
        <pertinence
          v-if="tabList == 4"
          ref="pertinence"
          :getData="getData"
        ></pertinence>
        <!-- 预测能力分析 -->
        <forecast
          v-if="tabList == 5"
          ref="forecast"
          :getData="getData"
        ></forecast>
        <!-- 调仓情况 -->
        <modem
          v-if="tabList == 6"
          ref="modem"
          :getData="getData"
          :getSingle="param"
        ></modem>
      </div>
      <div class="noData" v-else v-loading="loading">暂无数据</div>
    </div>
    <!-- 指引 -->
    <template v-if="stepType <= newGuideIdx">
      <div class="leadBox"></div>
    </template>
    <!-- 因子的弹窗 -->
    <divisor
      :headerData="subjectData"
      ref="divisor"
      @onSucceed="divisorSucceed"
      :symbolVisible="masterType"
      :getKsubject="getKsubject"
    ></divisor>
  </div>
</template>
<script>
import divisor from "@/components/subjectDialog/divisor.vue"; // 更换因子弹窗
import subject from "@/components/subjectDialog/subject.vue"; // 标的弹窗
import trajectory from "./singledetails/trajectory"; //业绩走势
import earnings from "./singledetails/earnings"; //收益详情
import distribution from "./singledetails/distribution"; //因子分布情况
import pertinence from "./singledetails/pertinence"; //相关性分析
import forecast from "./singledetails/forecast"; //预测能力分析
import modem from "./singledetails/modem"; //调仓情况
export default {
  components: {
    subject,
    trajectory,
    earnings,
    distribution,
    pertinence,
    forecast,
    modem,
    divisor,
  },
  data() {
    return {
      // 新手指引
      stepList: 1, // 步数
      stepType: 0, // 记录进入次数
      newGuideIdx: this.$store.state.newGuideIdx, // 限制次数
      initType: false,

      // 因子
      dataTOList: {}, // 已选择数据
      masterType: false,

      loading: false,
      tabList: 1,
      celdata: {},
      getData: {},
      // 标的
      getKsubject: {}, // 已选择标的数据
      symbolType: false,
      headerData: {},
      subjectData: {},
      factorInfoTOList: {},
      param: {
        factorName: "", // 因子名称
        investmentDomain: "", // 投资域
      },
    };
  },
  methods: {
     onload(){
      this.initType= true;
      this.stepType = 'null';
      this.codeDataChange();
    },
    // 投资域
    articleChange(item) {
      if(this.stepList==2){
        this.stepList++
      }
    },
    // 因子弹窗
    divisorSucceed(item, type) {
      this.masterType = false;
      if (type) {
        this.getKsubject = this.subjectData.factorInfoTOList.filter(
          (items) => items.factor_no == item
        )[0];
        this.param.factorName = item;
         if(this.stepList==1){
              this.stepList++
          }
        // this.getSingleFactorPerformance();
      }
    },
    // 弹窗
    symbolfun(type) {
      if (type == "divisor") {
        // 更换因子
        this.masterType = true;
      }
      // this.getKLineIndex();
    },
    // 新手指引
    localGet() {
      if (JSON.parse(localStorage.getItem("aloneanalysis"))) {
        this.stepType = Number(localStorage.getItem("aloneanalysis"));
        const webSizeIdx = Number(localStorage.getItem("aloneanalysis")) + 1;
        localStorage.setItem("aloneanalysis", webSizeIdx);
      } else {
        localStorage.setItem("aloneanalysis", 1);
      }
    },
    tab(type, item) {
      this.tabList = type;
      if (type == 1) {
        this.$nextTick(() => {
          this.$refs.trajectory.init();
        });
      }
    },
    // 标的\投资域
    codeDataChange() {
       this.initType= true;
      this.stepType = 'null';
      this.getSingleFactorPerformance();
    },
    // 因子绩效
    getSingleFactorPerformance() {
      this.loading = true;
      this.$api.hubei.getSingleFactorPerformance(this.param).then((res) => {
        this.getData = JSON.parse(JSON.stringify(JSON.parse(res)));
        this.$nextTick(() => {
          if (this.tabList == 1) {
            this.$refs.trajectory.init();
          } else if (this.tabList == 2) {
            this.$refs.earnings.init();
          } else if (this.tabList == 3) {
            this.$refs.distribution.init();
          } else if (this.tabList == 4) {
            this.$refs.pertinence.init();
          } else if (this.tabList == 5) {
            this.$refs.forecast.init();
          } else if (this.tabList == 6) {
            this.$refs.modem.init();
          }
          this.loading = false;
        });
      });
    },
    // 初始化
    ngOnInit() {
      this.$api.hubei.getFactorPerformanceParams().then((res) => {
        this.subjectData = res;
        // this.getKsubject = res.factorInfoTOList[0]; // 因子
        this.factorInfoTOList = res.codeDataTOList[0]; // 投资域
        // 获取总数据
        this.param.factorName = res.factorInfoTOList[0].factor_no;
        // this.param.investmentDomain = res.codeDataTOList[0].symbol;
        this.dataTOList = res.factorInfoTOList[0]; // 因子
        this.$nextTick(() => {
          this.$refs.divisor.ngOnInit();
        });
        // this.getSingleFactorPerformance();
        // this.$nextTick(() => {
        //   this.$refs.subject.ngOnInit();
        // });
      });
    },
  },
  created() {
    this.ngOnInit();
    // this.localGet();
    this.$ILab.StartStep("aloneanalysis")
  },
};
</script>
<style lang="less" scoped>
.headerList {
  li {
    font-size: 14px;
    color: #666666;
    margin-bottom: 20px;
    font-family: MicrosoftYaHei;
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-box;
    .titList {
      font-size: 14px;
      font-family: MicrosoftYaHei;
      color: #666666;
      line-height: 32px;
      span {
        padding-left: 27px;
      }
    }
    .tit {
      color: #3f98f1;
      line-height: 34px;

      color: #3f98f1;
      display: inline-block;
      width: 64px;
      line-height: 34px;
    }
    > span {
      display: inline-block;
      padding: 0 15px;
      height: 30px;
      line-height: 30px;
    }
    .titCenData {
      display: inline-block;
      padding: 0 15px;
      height: 30px;
      line-height: 30px;
    }
    .titCen {
      display: inline-block;
      padding: 0 15px;
      height: 30px;
      line-height: 30px;
      cursor: pointer;
      color: #333333;
      font-size: 14px;
    }
    // .titCen:hover {
    //   color: #fff;
    //   background: rgba(63, 152, 241, 1);
    //   border-radius: 4px;
    //   font-size: 14px;
    // }
  }
}
.navSvg {
  clear: both;
  overflow: hidden;
  margin: 0 auto;
  width: 800px;
  text-align: center;
  height: 50px;
  margin-bottom: 20px;

  li {
    float: left;
    width: 120px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: #666666;
    cursor: pointer;
    margin: 5px;
    border: 1px solid #3f98f1;
    border-radius: 4px;
    padding: 0 10px;
    &:hover{
    background: #3f98f1;
    border-radius: 4px;
    color: #ffffff;
    .change-my-color{
      fill: #fff;
    }
  }
  }
  .sele {
    background: #3f98f1;
    border-radius: 4px;
    color: #ffffff;
  }
 
}
 
.change-my-color {
  fill: #666666;
}
.change-sele-color {
  fill: #fff;
}
.noData {
  text-align: center;
  font-size: 18px;
  height: 150px;
  line-height: 150px;
}

// 新手指引
.leadBox {
  margin-left: -16px;
  background: rgba(51, 51, 51, 0.3);
  position: fixed;
  top: 0px;
  width: 100%;
  height: 100%;
  right: 0;
  bottom: 0;
}
.cardBox {
  position: absolute;
  left: 172px;
  z-index: 10;
  bottom: 84px;
  color: #fff;
  font-size: 24px;
}
.leadList {
  position: relative;
  z-index: 9;
  background: #ffffff;
  display: inline-block;
  border-radius: 10px;
  padding: 10px 10px 0px 10px;
  // .tit{
  //   margin-top: 10px;
  // }
  // pointer-events: none;
  .digBox {
    position: absolute;
    right: -225px;
    z-index: 10;
    top: 44px;
    color: #fff;
    font-size: 24px;
    h3 {
      margin-left: -119px;
    }
  }
}
.skip {
  position: absolute;
  right: 12%;
  top: 91px;
  font-size: 20px;
  color: #fff;
  cursor: pointer;
}
.nextStep {
  position: absolute;
  font-size: 21px;
  color: #fff;
  text-align: center;
  cursor: pointer;
  left: 500px;
  top: 421px;
}
.cardBox_p {
  width: 37px;
  height: 85px;
  background: #ffffff;
  border-radius: 33px;
  text-align: center;
  margin: 0 auto;
  padding: 10px;
  padding-top: 14px;
  .cardBox_lab1 {
    width: 17px;
    height: 36px;
    border-radius: 9px;
    border: 1px solid #979797;
    display: block;
  }
  .cardBox_lab2 {
    width: 14px;
    height: 14px;
    background: #d8d8d8;
    display: block;
    border-radius: 100%;
  }
}
</style>
